import { createSlice } from "@reduxjs/toolkit";

export const educationSystemsFilterInitialData = {
  name: "",
  regionId: "",
};

const educationSystemsSlice = createSlice({
  name: "educationSystems",
  initialState: {
    filtersData: educationSystemsFilterInitialData,
    hasSearchStarted: false,
  },
  reducers: {
    overrideFiltersData: (state, action) => {
      state.filtersData = action.payload;
    },
    updateHasSearchStarted: (state, action) => {
      state.hasSearchStarted = action.payload;
    },
  },
});

export const { overrideFiltersData, updateHasSearchStarted } = educationSystemsSlice.actions;

export default educationSystemsSlice.reducer;
